import Backbone from 'backbone'
import template from './success-dialog.hbs'

var SuccessDialog = Backbone.View.extend({

	className: 'success-dialog',

	/**
	 * If a nav (app-router.goTo) is performed and a guard is triggered, an that
	 * guard displays a success dialog, this attribute defers navigation until
	 * the user sees and dismisses the success dialog.
	 */
	awaitConfirmation: true,

	/**
	 * Returns a success message for display in a dialog.  For example, it is
	 * shown after creating a database import connection or importing users.
	 *
	 * @constructs
	 *
	 * @param {Object} [options.title] If not provided `context` must be overridden
	 * @param {Object} [options.message] If not provided `context` must be overridden
	 *
	 * @param {Backbone.Model} options.model
	 */
	initialize(options = {}) {
		this.options = options
	},

	render() {
		this.$el.empty().append(template(this.context()))
		return this
	},

	/**
	 * Returns { title, message }.  Note the title should NOT be escaped, and
	 * the message SHOULD be escaped.
	 */
	context() {
		return {
			title: this.options.title,
			message: this.options.message
		}
	},

	done: () => this.trigger('done')

})

export default SuccessDialog

SuccessDialog.__filename__ = 'components/success-dialog.js'
